import { observable, makeObservable } from 'mobx'
import { SkillDTO } from '../dtos/skill'
import { DateZero, maybeParseDate } from 'utils/date-util'
import { Model } from 'infra/model'
import { Id } from 'types/definitions'

export default class Skill extends Model<SkillDTO, Skill> {
  @observable id = Id.none
  @observable name = ''
  @observable description = ''
  @observable workspaceId = Id.none
  @observable dateCreated: Date = DateZero()
  @observable dateModified: Date = DateZero()

  constructor() {
    super()

    makeObservable(this)
  }

  parse(json: SkillDTO): Partial<Skill> {
    return {
      id: json.id,
      name: json.name,
      workspaceId: json.workspace_id,
      description: json.description || '',
      dateCreated: maybeParseDate(json.date_created),
      dateModified: maybeParseDate(json.date_modified),
    }
  }
}
